import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import MetricCard from "./MetricCard";

const TeamMetrics = ({ period, reduxData, loading, getPeriodLabel,onEmployeeClick }) => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    if (reduxData && Object.keys(reduxData).length > 0) {
      setMetrics(reduxData);
    }
  }, [reduxData]);

  if (!metrics) return <div>Loading...</div>;

  return (
    <div className="team-metrics">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          <i className="fas fa-users me-2 icon-orange"></i>
          {metrics.teamName} Performance - {getPeriodLabel(period)}
        </h5>
        <div className="text-muted small">
          Team Members: {metrics.totalMembers}
        </div>
      </div>

      {/* Team Summary Cards */}
      <Row className="mb-4">
        <Col md={3} sm={6} className="mb-3">
          <MetricCard title="Total Assigned" value={metrics.assignedTickets} icon="fa-ticket-alt" color="#0d6efd" />

        </Col>
        <Col md={3} sm={6} className="mb-3">
          <MetricCard title="Total Resolved" value={metrics.resolvedTickets} icon="fa-check-circle" color="#28a745" />

        </Col>
        <Col md={3} sm={6} className="mb-3">
          <MetricCard
            title="Team Efficiency"
            value={`${metrics.teamEfficiency}%`}
            icon="fa-tachometer-alt"
            color="#6f42c1"
            subtitle="Excellent"
          />
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <MetricCard
            title="Avg Resolution Time"
            value={`${metrics.avgResolutionTime}h`}
            icon="fa-hourglass-half"
            color="#17a2b8"
            subtitle="Target: <24h"
          />
        </Col>
      </Row>

      {/* Team Member Performance Table */}
      <Row className="mb-4">
        <Col md={8}>
          <Card className="shadow-sm">
            <Card.Header>
              <h6 className="mb-0">Team Member Performance</h6>
            </Card.Header>
            <Card.Body>
              <Table responsive striped hover className="mb-0">
                <thead>
                  <tr>
                    <th>Team Member</th>
                    <th className="text-center">Assigned</th>
                    <th className="text-center">Resolved</th>
                    <th className="text-center">Resolution Rate</th>                    
                  </tr>
                  
                </thead>
                <tbody>
                  {metrics.members.map((member) => {
                    const resolutionRate = member.assigned > 0
                      ? ((member.resolved / member.assigned) * 100).toFixed(1)
                      : 0;
                    const performance = resolutionRate >= 80 ? 'excellent' : resolutionRate >= 60 ? 'good' : 'needs-improvement';

                    return (
                      <tr key={member.id}
                          onClick={() => onEmployeeClick(member.id, member.name)}
                          style={{ cursor: "pointer" }}>
                        <td>
                          <i className="fas fa-user-circle me-2 text-muted"></i>
                          {member.name}
                        </td>
                        <td className="text-center">{member.assigned}</td>
                        <td className="text-center">{member.resolved}</td>
                        <td className="text-center">
                          <span className={`badge bg-${performance === 'excellent' ? 'success' : performance === 'good' ? 'info' : 'warning'}`}>
                            {resolutionRate}%
                          </span>
                        </td>
                        
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        {/* Category Breakdown */}
        <Col md={4}>
          <Card className="shadow-sm">
            <Card.Header>
              <h6 className="mb-0">Tickets by Category</h6>
            </Card.Header>
            <Card.Body>
              {metrics.categoryBreakdown.map((cat, index) => {
                const total = metrics.categoryBreakdown.reduce((sum, c) => sum + c.count, 0);
                const percentage = total > 0 ? ((cat.count / total) * 100).toFixed(1) : 0;

                return (
                  <div key={index} className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="small">{cat.category}</span>
                      <span className="small font-weight-bold">{cat.count} ({percentage}%)</span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar"
                        style={{
                          width: `${percentage}%`,
                          backgroundColor: `hsl(${index * 60}, 70%, 50%)`,
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TeamMetrics;
